<template>
  <div class="learning_note">
    <div class="note_top" v-if="listTotal">
      你记录了
      <span class="top_active_text">{{ listTotal }}</span> 篇笔记，继续努力哦～
    </div>
    <div class="note_list" ref="content" :class="{ expanded: isExpanded }" v-if="listTotal">
      <div class="note_one mar_bottom_20 flex Flexalign" v-for="(item, index) in noteList" :key="index">
        <div>
          <el-image class="video_img" :src="imgPath(item.courseCoverImg)"></el-image>
        </div>
        <div class="note_right mar_left_20 flex-1 flex flexcolumn FlexBetween">
          <div class="flex Flexalign course_resource">
            <div class="toverflow course_resource_box">
              来自课程：<span class="">{{ item.courseName }}</span>
            </div>
            <div class="mar_left_20 toverflow course_resource_box">
              来自章节：<span class="">{{
                item.chapterId + item.chapterName
              }}</span>
            </div>
          </div>
          <div class="note_info flex flexcolumn FlexBetween FlexAround" v-if="!item.isEdit">
            <div class="note_content">{{ item.content }}</div>
            <div class="note_time">{{ item.updateTime }}</div>
          </div>
          <div class="note_info" v-else>
            <el-input v-model="item.content" style="width: 100%; height: 100%" :autosize="false" type="textarea"
              placeholder="Please input" />
          </div>
          <div class="note_action FlexjustifyEnd flex">
            <div class="note_edit cursor_pointer" v-if="!item.isEdit" @click="editNote(item)">
              修改笔记
            </div>
            <div class="note_cancel cursor_pointer" v-if="item.isEdit" @click="cancelEdit(item)">
              取消
            </div>
            <div class="note_selete mar_left_20 cursor_pointer" v-if="!item.isEdit" @click="deleteNote(item)">
              删除
            </div>
            <div class="note_edit mar_left_20 cursor_pointer" v-if="item.isEdit" @click="saveEdit(item)">
              保存
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination_box mar_top_20 flex FlexjustifyEnd" v-if="listTotal && listTotal>listQuery.pageSize">
      <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]" :total="listTotal"
        v-model:page-size="listQuery.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
    <div v-if="!listTotal">
      <moe-empty :url="'note_empty_bg_img.png'" emptyText="暂无笔记"></moe-empty>
    </div>
    <!-- <div class="more_load flex Flexalign Flexjustify cursor_pointer" v-if="showLoadMore" @click="toggleExpand">
            {{ isExpanded ? '收起' : '查看更多记录' }}
            <el-icon v-if="!isExpanded">
                <ArrowDown />
            </el-icon>
            <el-icon v-else>
                <ArrowUp />
            </el-icon>
        </div> -->
  </div>
</template>

<script>
export default {
  name: "GjkcH5LearningNote",

  data() {
    return {
      noteList: [],
      isExpanded: false,
      showLoadMore: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        courseId: "",
        chapterId: "",
      },
      listTotal: 0,
    };
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.$nextTick(this.checkOverflow);
      },
    },
  },

  mounted() {
    // this.checkOverflow();
    this.getNoteList();
  },

  methods: {
    checkOverflow() {
      if (!this.$refs.content) return;
      this.showLoadMore =
        this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    // 获取笔记列表
    getNoteList() {
      this.$Api.course.getNoteList(this.listQuery).then((res) => {
        this.noteList = res.data.data.list.map((item) => {
          return { ...item, isEdit: false };
        });
        this.listTotal = res.data.data.total?Number(res.data.data.total):0;
        setTimeout(() => {
          this.checkOverflow();
        }, 500);
      });
    },
    // 编辑
    editNote(info) {
      info.isEdit = true;
    },
    // 取消
    cancelEdit(info) {
      info.isEdit = false;
    },
    // 删除
    deleteNote(info) {
      this.$Api.course
        .deleteNote(info.noteId)
        .then((res) => {
          console.log(res);
          this.$Dialog.toast("删除成功");
          this.getNoteList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 保存
    saveEdit(info) {
      info.isEdit = false;
      let listData = {
        noteId: info.noteId,
        chapterId: info.chapterId,
        content: info.content,
        imgs: "",
      };
      this.$Api.course
        .editNote(listData)
        .then((res) => {
          console.log(res);
          this.$Dialog.toast("保存成功");
          this.getNoteList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSizeChange() {
      this.getNoteList();
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getNoteList();
    },
  },
};
</script>

<style lang="scss" scoped>
.learning_note {
  .note_top {
    font-size: 18px;
    color: #111111;
    margin: 20px 0;

    .top_active_text {
      color: #13d6aa;
    }
  }

  .note_list {
    // max-height: 650px;
    // overflow: hidden;

    .note_one {
      width: 810px;
      height: 152px;
      background: #f5f6f8;
      border-radius: 10px;
      padding: 20px;
      box-sizing: border-box;

      .video_img {
        width: 200px;
        height: 112px;
      }

      .note_right {
        height: 112px;

        .course_resource {
          color: #666666;

          .course_resource_box {
            max-width: 220px;
          }

          .course_resource_active {
            color: #13d6aa;
          }
        }

        .note_info {
          height: 63px;

          .note_content {
            color: #333333;
          }

          .note_time {
            color: #999999;
          }
        }

        .note_action {
          .note_edit {
            color: #303030;
          }
          .note_edit:hover{
            color: #13d6aa;
          }

          .note_cancel {
            color: #a3a3a3;
          }

          .note_selete {
            color: #ff6619;
          }
        }
      }
    }
  }

  .note_list.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 200px;
    height: 35px;
    background: #f5f6f8;
    border-radius: 8px;
    line-height: 35px;
    text-align: center;
    margin: 10px auto;
  }
}
</style>
